import { useCallback, useEffect, useRef, useState } from "react"
import { ErrorCard, LoadingCard, MainContainer, VirtualizeAutoComplete } from "../../components"
import { ENUM_INVOICE_TYPE } from "../creditdebitnote/enum"
import { Button, Autocomplete, AutocompleteItem, Checkbox, Input, Select, SelectItem, Textarea } from "@nextui-org/react"
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import dayjs from "dayjs"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { apiRoute, ENUM_INPUT_TYPE, ENUM_MOD_NAME, ENUM_MOD_PARAMETER, getModMandatory, getModValue, getModVisiblity, linksUrl } from "../../constants/enum"
import { isMobile } from "react-device-detect"
import { useFetchWithBody, usePost } from "../../api/reactQueryCustomHooks"
import { useSelector } from "react-redux"
import { faCancel, faPlus, faSave, faSquareXmark, faTrashCan } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { toast } from "react-toastify"
import { useNavigate } from "react-router-dom"


const EwayBillDetailEntry = ({ eWayDetail, handleEwayBillDeail }) => {
    const { compCode, isMultipleCompany, compState } = useSelector((state) => state.company)
    const { user } = useSelector((state) => state.auth);
   // const navigate = useNavigate();
    const [data, setData] = useState(eWayDetail)

console.log(data)
    // const onSuccessTasks = (data) => {
    //     if (data)

    //         navigate(linksUrl.transaction.journalVoucherEntry.journalVoucherEntryMaster);
    // }
    // const { isError, isPending, mutate: funAddUpdate } = usePost({
    //     url: apiRoute.transaction.graySaleChallanEntry.updateEwayBill,
    //     queryKey: "funAddUpdateEwayBill",
    //     onSuccessTasks
    // })

    const formField = {
        eWayBillNo: "eWayBillNo",
        eWayBillDate: "eWayBillDate",
        irnNo: "irnNo",
        ackNo: "ackNo",
        ackDate: "ackDate",
    }

    // const emptyFormField = Object.keys(formField).reduce((acc, key) => {
    //     if (key == formField.eWayBillDate || formField.ackDate)
    //         acc[key] = null
    //     else acc[key] = ""
    //     return acc
    // }, {})


    // const [formData, setFormData] = useState({
    //     ...emptyFormField
    // })

    const inputBoxes = {
        Row1: [
            {
                id: formField.eWayBillNo,
                name: formField.eWayBillNo,
                placeholder: "E-Way Bill No.",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: true,
            },
            {
                id: formField.eWayBillDate,
                name: formField.eWayBillDate,
                placeholder: "E-way Bill Date",
                type: ENUM_INPUT_TYPE.date,
                size: "sm",
                label: "",
                isrequired: true,
            },

        ],
        Row2: [{
            id: formField.irnNo,
            name: formField.irnNo,
            placeholder: "EInvoice-IRN No",
            type: ENUM_INPUT_TYPE.multiline,
            size: "sm",
            label: "",
            isrequired: true,
        }],
        Row3: [
            {
                id: formField.ackNo,
                name: formField.ackNo,
                placeholder: "EInvoice-ACK No.",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: true,
            },
            {
                id: formField.ackDate,
                name: formField.ackDate,
                placeholder: "EInvoice-ACK Date",
                type: ENUM_INPUT_TYPE.date,
                size: "sm",
                label: "",
                isrequired: true,
            },

        ],


    }

    const handleChange = (e, id) => {
        if (id == formField.ackDate || id == formField.eWayBillDate) {
            setData({ ...data, [id]: e })
        } else {
            const { name, value } = e.target
            setData({ ...data, [name]: value })
        }

    }
    useEffect(() => {
        handleEwayBillDeail(data)
    }, [handleChange])


    const [errors, setErrors] = useState({})

    // const validateForm = () => {
    //     const newErrors = {}

    //     // Validate username
    //     if (formData[formField.eWayBillNo] == "") {
    //         newErrors[formField.eWayBillNo] = "E-Way Bill No  required"
    //     }

    //     if (formData[formField.irnNO] == "" || formData[formField.irnNO] == "0") {
    //         newErrors[formField.irnNO] = "IRN No. required"
    //     }

    //     if (formData[formField.ackNo] == "" || formData[formField.ackNo] == "0") {
    //         newErrors[formField.ackNo] = "ACK No.  required"
    //     }
    //     if (formData[formField.ackDate] == null || formData[formField.ackDate] == "" || formData[formField.ackDate] == "Invalid Date") {
    //         newErrors[formField.ackDate] = "ACk Date  required"
    //     }
    //     if (formData[formField.eWayBillDate] == null || formData[formField.eWayBillDate] == "" || formData[formField.eWayBillDate] == "Invalid Date") {
    //         newErrors[formField.eWayBillDate] = "E-Way Bill Date  required"
    //     }


    //     setErrors(newErrors)

    //     // Return true if there are no errors
    //     return Object.keys(newErrors).length === 0
    // }

    // useEffect(() => {
    //     validateForm();
    // }, [formData])

    const handleSubmit = (e) => {
        e.preventDefault()

        // const validate_form = validateForm()
        // if (validate_form) {
        // const { comp_code, transaction_id, bill_type } = detailParams
        //funAddUpdate({
        // data: {
        // comp_code: comp_code
        // , bill_type: bill_type
        // , trans_id: transaction_id,
        // ewbill_no: formData[formField.eWayBillNo],
        // ewbill_date: formData[formField.eWayBillDate],
        // eirn_no: formData[formField.irnNO],
        // einv_ackno: formData[formField.ackNo],
        // einv_ackdate: formData[formField.ackDate]
        // }
        // })
        // }
    }

    // useEffect(() => {

    //     if (eWayDetail) {

    //         setFormData({
    //             ...formData,
    //             [formField.eWayBillNo]: data[formField.eWayBillNo] ?? '',
    //             [formField.eWayBillDate]: data[formField.eWayBillDate] ?? null,
    //             [formField.irnNo]: data[formField.irnNo] ?? '',
    //             [formField.ackNo]: data[formField.ackNo] ?? '',
    //             [formField.ackDate]: data[formField.ackDate] ?? null
    //         })
    //     }
    // }, [eWayDetail])


    // if (isPending) {
    //     return <LoadingCard />;
    // }
    // if (isError) {
    //     return <ErrorCard />;
    // }

    return (
        <div>
            <MainContainer
                pageName={`E-way Bill Details`}
                breadcrumbs={["Transaction", "E-Way Bill Detail"]}

            >
                <div shadow="sm" className="mb-3 w-full">
                    <form onSubmit={handleSubmit} autoComplete='off'>
                        {
                            Object.keys(inputBoxes).map((key, ind) => (
                                <div key={key + ind}>
                                    <div className={` ${isMobile ? 'flex-wrap' : ''}   flex gap-4 align-top items-baseline mb-2 `}>
                                        {
                                            inputBoxes[key].map((item, indx) =>
                                                item.type == ENUM_INPUT_TYPE.select ? (
                                                    <></>
                                                ) : item.type == ENUM_INPUT_TYPE.autocomplete ? (
                                                    <></>
                                                ) : item.type == ENUM_INPUT_TYPE.date ? (
                                                    <div className=" w-full flex items-center">
                                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                            <DatePicker
                                                                label={item.placeholder}
                                                                views={["day", "month", "year"]}
                                                                format="DD/MM/YYYY"
                                                                value={
                                                                    data[item.name]
                                                                        ? dayjs(data[item.name])
                                                                        : data[item.name]
                                                                }
                                                                onChange={(newValue) => {
                                                                    handleChange(dayjs(newValue).format("YYYY-MM-DD"), item.name)

                                                                }}
                                                                //isRequired={item.required}
                                                                className="w-full "
                                                                slotProps={{
                                                                    textField: { size: "small", error: errors[item.name], helperText: errors[item.name], required: true },
                                                                }}
                                                            />
                                                        </LocalizationProvider>
                                                    </div>
                                                ) : item.type == ENUM_INPUT_TYPE.multiline ? (
                                                    <Textarea
                                                        //  type={item.type}
                                                        name={item.name}
                                                        id={item.name}
                                                        isInvalid={errors[item.name]}
                                                        errorMessage={errors[item.name]}
                                                        placeholder={item.placeholder}
                                                        label={item.placeholder}
                                                        labelPlacement="outside"
                                                        isRequired={item.isrequired}
                                                        value={data[item.name]}
                                                        variant="bordered"
                                                        onChange={(e) => handleChange(e, "")}
                                                        className="w-full"
                                                        classNames={{
                                                            label: "text-xs text-black font-bold",
                                                        }}
                                                    >

                                                    </Textarea>
                                                )
                                                    : (
                                                        <Input
                                                            type={item.type}
                                                            name={item.name}
                                                            id={item.name}
                                                            isInvalid={errors[item.name]}
                                                            errorMessage={errors[item.name]}
                                                            placeholder={item.placeholder}
                                                            label={item.placeholder}
                                                            labelPlacement="outside"
                                                            isRequired={item.isrequired}
                                                            value={data[item.name]}
                                                            variant="bordered"
                                                            onChange={(e) => handleChange(e, "")}
                                                            size={"md"}
                                                            classNames={{
                                                                label: "text-xs text-black font-bold",
                                                            }}
                                                        ></Input>
                                                    )
                                            )
                                        }
                                    </div>

                                </div>

                            ))
                        }

                        <div className="justify-center flex gap-5 mt-5">
                            {/*  <Button
                                color="primary"
                                type="submit"
                                size="md"
                                variant="shadow"
                                tabIndex={-1}
                                startContent={<FontAwesomeIcon icon={faSave} />}
                            >
                                Save E-way Bill Detail
                            </Button>
                             <Button
                                color="danger"
                                variant="shadow"
                                size="md"
                                tabIndex={-1}
                                onPress={handleClickPrev}
                                startContent={<FontAwesomeIcon icon={faCancel} />}
                            >
                                Cancel
                            </Button> */}
                        </div>
                    </form>
                </div>
            </MainContainer>
        </div>
    )

}
export default EwayBillDetailEntry